import React from 'react';
import { FormattedMessage } from 'react-intl';

import { SwitchBox } from '../../../molecules/switch-box';

export const SettingsBoilerSpotBlocking = () => {
  return (
    <>
      <SwitchBox
        title={
          <FormattedMessage
            id="boiler.settings.spot-mi"
            defaultMessage="Blokovat ohřev při střední ceně spotu"
          />
        }
        switchVariableId="HW_SPOT_MI_STOP"
        visibility={{ variableId: 'SP_INSTALL' }}
        fullWidth
      />
      <SwitchBox
        title={
          <FormattedMessage
            id="boiler.settings.spot-hi"
            defaultMessage="Blokovat ohřev při vysoké ceně spotu"
          />
        }
        switchVariableId="HW_SPOT_HI_STOP"
        visibility={{ variableId: 'SP_INSTALL' }}
        fullWidth
      />
    </>
  );
};
